import { render, staticRenderFns } from "./leaveWordsManagement.vue?vue&type=template&id=48592942&scoped=true&"
import script from "./leaveWordsManagement.vue?vue&type=script&lang=js&"
export * from "./leaveWordsManagement.vue?vue&type=script&lang=js&"
import style0 from "./leaveWordsManagement.vue?vue&type=style&index=0&id=48592942&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48592942",
  null
  
)

export default component.exports